<template>
	<div class="">
		<div class="bg-gradient-to-b from-ihh-pink to-ihh-light-lavendar max-w-md overflow-hidden">
			<div class="flex w-full justify-center">
				<div class="">
					<div
						class="flex w-full justify-center text-center text-ihh-midnight-gray text-2xl lg:text-2xl font-semibold tracking-wide whitespace-nowrap m-auto capitalize pt-8"
					>
						You may also like
					</div>

					<!-- Scrollable Featured Items -->
					<div class="flex w-full max-w-[400px] overflow-x-auto scroll-smooth px-6 mr-6">
						<div class="flex space-x-6 w-full max-w-sm sm:max-w-[400px]">
							<!-- Featured Items -->
							<div v-for="(feature, a) in featured" :key="a">
								<div class="relative z-10 flex w-full justify-end translate-y-11 -translate-x-2">
									<div class="bg-gradient-to-b from-ihh-pink to-ihh-purple p-1.5 rounded-md shadow">
										<img src="/images/ob-heart-0129.svg" class="w-6 h-6" />
									</div>
								</div>

								<div class="relative group flex w-32 h-32 justify-center bg-ihh-white rounded-xl items-center p-4 overflow-hidden shadow">
									<img class="w-full object-center object-cover" :src="feature.image" alt="featured images" />
									<div
										class="absolute inset-0 flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100"
									>
										<button
											class="font-medium text-sm md:text-base text-ihh-midnight-gray py-3 w-full bg-ihh-dark-salmon hover:bg-ihh-salmon tracking-wide transition transform ease-in-out whitespace-nowrap"
										>
											Add to Bag
										</button>
									</div>
								</div>

								<!-- Item Information -->
								<div class="my-4">
									<div class="flex w-full px-2 text-base flex-col">
										<a href="/features" class="text-start font-semibold tracking-wide text-ihh-midnight-gray break-words mr-2">{{ feature.title }}</a>
										<div class="justify-end w-full">
											<div class="text-ihh-midnight-gray text-sm font-normal tracking-wide text-start pt-2">${{ feature.price }}</div>
										</div>
									</div>
								</div>
							</div>
							<!-- End of Featured Item -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import NextButtonsGray from './next-buttons-gray.vue'

export default {
	components: { NextButtonsGray },
	data() {
		return {
			featured: [
				{
					title: 'Herbal Afterbirth Sitz Bath dry herbs, 12oz.',
					image: '/images/Herbal-Bath-2-0129.jpg',
					price: '12.49',
				},
				{
					title: 'Afterease for After Birth Contractions by Wishgarden',
					image: '/images/AFTPTg2-AfterEase-0129.jpg',
					price: '24.99',
				},
				{
					title: 'Bio-K-Mulsion Oral Vitamin K by Bioptics Research, 1oz',
					image: '/images/Oral-Vitamin-K-0129.jpg',
					price: '29.99',
				},
				{
					title: 'Birth Pool Liners',
					image: '/images/category-image-water-birth-birth-pool-liners-0129.jpg',
					price: '73.60',
				},
				{
					title: 'Water Birth Accessories',
					image: '/images/category-image-water-birth-accessories-0129.jpg',
					price: '33.60',
				},
				{
					title: 'Complete Water Birth Packages',
					image: '/images/complete-birth-kit.jpg',
					price: '98.60',
				},
				{
					title: 'Rad-G Masimo Pulse Oximeter Complete Set',
					image: '/images/Rad-G-3Q-rt-0129.jpg',
					price: '699.00',
				},
			],
		}
	},
}
</script>
